import SymbolComponent from "slotworks/components/matrix/symbol/symbol-component";
import SymbolWinResult from "slotworks/model/gameplay/records/results/symbol-win-result";
import Contract from "slotworks/utils/contracts/contract";
import Parallel from "slotworks/utils/contracts/parallel";

/**
 * autoReset to automatically call static() on completion
 */
export function HighlightSymbolsCommand(symbols: SymbolComponent[], result?: SymbolWinResult, autoReset?: boolean): Contract<void> {
    const winningSymbolHighlightMethods = symbols.map((symbol) => highlightSymbol(symbol, result, autoReset));

    return new Parallel(winningSymbolHighlightMethods);
}

function highlightSymbol(symbol: SymbolComponent, result?: SymbolWinResult, autoReset?: boolean) {
    symbol.static();
    return () => new Contract((resolve) => {
        symbol.highlight(result).then(() => {
            if (autoReset) {
                symbol.static();
            }
            resolve();
        });
    });
}
